/* AO Home v5 · commerce chapters (U3) — two behaviours only:
   1. the mobile sticky bar's show / hide (the PDP IntersectionObserver pattern, assets/aocdx-pdp.js L363-372);
   2. chapter 11's offer-row selection (which of the three proxy buttons is on screen).
   NO cart code: every add still goes through assets/ao-home-v3-commerce.js — the real forms in chapter 04 and the
   ao-home-v4-proxy buttons everywhere else. This file never touches [data-ao-home-*] attributes.
   Guard + delegated listeners + shopify:section:load / unload cleanup (U5 §7.6). */
(function () {
  'use strict';
  if (window.AoHomeV5Commerce) return;

  var PHONE = '(max-width: 749px)';
  var STICKY = '[data-ao-home-v5-sticky]';
  var OFFERS = '[data-v5-offers]';
  var RESERVED = 'ao-home-v5-sticky-reserved';

  var sticky = null; // { el, heroObserver, blockObserver, heroOut, blockers }

  var phone = function () {
    return typeof window.matchMedia === 'function' ? window.matchMedia(PHONE).matches : window.innerWidth <= 749;
  };

  /* ---------------------------------------------------------------- sticky */

  var paint = function () {
    if (!sticky || !sticky.el.isConnected) return;
    var show = sticky.heroOut && sticky.blockers.size === 0 && phone();
    if (show === sticky.shown) return;
    sticky.shown = show;
    sticky.el.classList.toggle('is-visible', show);
    if (show) {
      sticky.el.removeAttribute('inert');
      sticky.el.removeAttribute('aria-hidden');
    } else {
      sticky.el.setAttribute('inert', '');
      sticky.el.setAttribute('aria-hidden', 'true');
    }
  };

  var blockerTargets = function (el) {
    var list = [];
    var push = function (node) { if (node && list.indexOf(node) === -1) list.push(node); };
    // chapter 04's own cards, chapter 11's close block and the footer (hidden once it is half on screen, §6.13)
    var root = el.closest('.ao-home-v5-host') || document;
    push(root.querySelector('.ao-home-v5-choose__cards'));
    document.querySelectorAll('.ao-home-v5-begin, .ao-home-v3-footer').forEach(push);
    return list;
  };

  var teardownSticky = function () {
    if (!sticky) return;
    if (sticky.heroObserver) sticky.heroObserver.disconnect();
    if (sticky.blockObserver) sticky.blockObserver.disconnect();
    document.body.classList.remove(RESERVED);
    sticky = null;
  };

  var bootSticky = function () {
    var el = document.querySelector(STICKY);
    if (sticky && sticky.el === el && el && el.isConnected) {
      // targets may have appeared (another chapter loaded in the editor): re-observe the blockers
      if (sticky.blockObserver) {
        sticky.blockObserver.disconnect();
        sticky.blockers.clear();
        blockerTargets(el).forEach(function (node) { sticky.blockObserver.observe(node); });
        paint();
      }
      return;
    }
    teardownSticky();
    if (!el) return;
    if (typeof window.IntersectionObserver !== 'function') return;

    sticky = { el: el, heroOut: false, blockers: new Set(), shown: null, heroObserver: null, blockObserver: null };
    document.body.classList.add(RESERVED);

    var heroSelector = el.getAttribute('data-v5-hero-target') || '';
    var hero = (heroSelector && document.querySelector(heroSelector)) || document.querySelector('#top');
    if (hero) {
      sticky.heroObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // the bar appears only after the hero's CTA has scrolled ABOVE the viewport
          sticky.heroOut = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        });
        paint();
      }, { threshold: 0 });
      sticky.heroObserver.observe(hero);
    } else {
      sticky.heroOut = true;
    }

    sticky.blockObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var footer = entry.target.classList.contains('ao-home-v3-footer');
        var on = footer ? entry.intersectionRatio >= 0.5 : entry.isIntersecting;
        if (on) sticky.blockers.add(entry.target); else sticky.blockers.delete(entry.target);
      });
      paint();
    }, { threshold: [0, 0.5] });
    blockerTargets(el).forEach(function (node) { sticky.blockObserver.observe(node); });

    paint();
  };

  /* ------------------------------------------------------- 11 · offer rows */

  var selectOffer = function (input) {
    if (!input) return;
    var group = input.closest(OFFERS);
    if (!group) return;
    var kind = input.value;
    group.querySelectorAll('[data-v5-offer]').forEach(function (node) {
      var row = node.closest('.ao-home-v5-card--offer');
      if (row) row.classList.toggle('is-selected', node === input);
    });
    var scope = group.parentNode;
    if (!scope) return;
    scope.querySelectorAll('[data-v5-offer-cta]').forEach(function (node) {
      node.classList.toggle('is-active', node.getAttribute('data-v5-offer-cta') === kind);
    });
  };

  var syncOffers = function () {
    document.querySelectorAll(OFFERS).forEach(function (group) {
      var checked = group.querySelector('[data-v5-offer]:checked');
      if (checked) selectOffer(checked);
    });
  };

  var onChange = function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-v5-offer]')) return;
    if (input.checked) selectOffer(input);
  };

  /* -------------------------------------------------------------- lifecycle */

  var boot = function () {
    bootSticky();
    syncOffers();
  };

  document.addEventListener('change', onChange);
  if (typeof window.matchMedia === 'function') {
    var mq = window.matchMedia(PHONE);
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', paint);
    else if (typeof mq.addListener === 'function') mq.addListener(paint);
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (event) {
    var scope = event.target;
    if (sticky && scope && scope.contains && scope.contains(sticky.el)) teardownSticky();
    boot();
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) boot();
    // History can restore native radio state without bfcache, after pageshow.
    // Reconcile presentation from that checked radio; never submit or add here.
    window.requestAnimationFrame(syncOffers);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.AoHomeV5Commerce = { version: 1, boot: boot, syncOffers: syncOffers };
})();
